import React from 'react';
import Select from 'react-select';

const AllowedBranchesSelector = ({ 
    allBranches = [], 
    selectedBranches = [], 
    onBranchesChange, 
    isReadOnly = false 
}) => {
    const allBranchValues = allBranches.map(b => b.branch);
    const isAllSelected = selectedBranches.length === allBranchValues.length && allBranchValues.length > 0;

    const handleSelectAllChange = (e) => {
        if (isReadOnly) return;
        
        // ✅ REMOVED preventDefault and stopPropagation - they were blocking the checkbox update
        
        if (!isAllSelected) {
            // Select all branches
            onBranchesChange([...allBranchValues]);
        } else {
            // Deselect all branches
            onBranchesChange([]);
        }
    };

    const handleMultiSelectChange = (selected) => {
        if (isReadOnly) return;
        const newSelection = selected ? selected.map(v => v.value) : [];
        onBranchesChange(newSelection);
    };

    return (
        <div className="form-group">
            <label>Allowed Branches <span className="mandatory">*</span></label>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {/* Select All Checkbox */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <input
                        type="checkbox"
                        className='cb'
                        checked={isAllSelected}
                        onChange={handleSelectAllChange}
                        disabled={isReadOnly}
                        style={{ 
                            cursor: isReadOnly ? 'not-allowed' : 'pointer'
                        }}
                    />
                    <span 
                        style={{ 
                            color: isReadOnly ? '#999' : 'inherit',
                            userSelect: 'none',
                            cursor: isReadOnly ? 'not-allowed' : 'default'
                        }}
                    >
                        All Branches
                    </span>
                </div>

                {/* Multi-select Dropdown */}
                <Select
                    isMulti
                    isDisabled={isReadOnly}
                    options={allBranches.map(b => ({
                        value: b.branch,
                        label: b.branch
                    }))}
                    value={selectedBranches.map(branch => ({
                        value: branch,
                        label: branch
                    }))}
                    onChange={handleMultiSelectChange}
                    placeholder="Select allowed branches..."
                    closeMenuOnSelect={false}
                    hideSelectedOptions={false}
                    styles={{
                        control: (base) => ({
                            ...base,
                            backgroundColor: isReadOnly ? '#f5f5f5' : base.backgroundColor,
                            cursor: isReadOnly ? 'not-allowed' : 'default',
                            minHeight: '42px'
                        }),
                        multiValue: (base) => ({
                            ...base,
                            backgroundColor: isReadOnly ? '#e0e0e0' : '#e3f2fd'
                        }),
                        multiValueLabel: (base) => ({
                            ...base,
                            color: '#1976d2'
                        }),
                        placeholder: (base) => ({
                            ...base,
                            color: '#999'
                        })
                    }}
                />

                {/* Info Display */}
                {selectedBranches.length > 0 && selectedBranches.length < allBranchValues.length && (
                    <div
                        style={{
                            fontSize: '13px',
                            color: '#2563eb',
                            padding: '8px 12px',
                            backgroundColor: '#eff6ff',
                            borderRadius: '4px',
                            border: '1px solid #bfdbfe'
                        }}
                    >
                        <strong>Selected ({selectedBranches.length} of {allBranchValues.length}):</strong>
                        <div style={{ marginTop: '4px' }}>
                            {selectedBranches.join(', ')}
                        </div>
                    </div>
                )}

                {isAllSelected && allBranchValues.length > 0 && (
                    <div
                        style={{
                            fontSize: '13px',
                            color: '#059669',
                            padding: '8px 12px',
                            backgroundColor: '#d1fae5',
                            borderRadius: '4px',
                            border: '1px solid #6ee7b7',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px'
                        }}
                    >
                        <span style={{ fontSize: '16px' }}>✓</span>
                        <span>All branches selected ({selectedBranches.length} branches)</span>
                    </div>
                )}

                {selectedBranches.length === 0 && (
                    <div
                        style={{
                            fontSize: '13px',
                            color: '#dc2626',
                            padding: '8px 12px',
                            backgroundColor: '#fee2e2',
                            borderRadius: '4px',
                            border: '1px solid #fecaca'
                        }}
                    >
                        ⚠ Please select at least one branch
                    </div>
                )}
            </div>
        </div>
    );
};

export default AllowedBranchesSelector;